import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/MtoPermisosNivelesView',
    name: 'MtoPermisosNivelesView',
    component: () =>
      import('../views/configuracion/permisos-niveles/PermisosNivelesView.vue'),
    meta: {
      title: 'Arbol de Decreto',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('MtoPermisosNivelesView'),
      bread: {
        path: [
          'Configuración',
        ],
      },
    },
  },
];

